import React from 'react';
import { Create } from 'react-admin';
import { EquipmentForm } from '../../components/shared/EquipmentForm';

export const EquipmentCreate = () => (
  <Create title="Add Company Vehicle">
    <EquipmentForm />
  </Create>
);